import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Modal } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import MainButton from '../MUI/MainButton';
import { setLeaveContractPage } from '../../redux/modules/contract';
import { setMustToLogOut } from '../../redux/modules/auth';

import styles from './LeaveWarningModal.module.scss';

const LeaveWarningModal = (props) => {
  const {
    modalHeaderText,
    modalText,
    locationsWhitelist, // these locations will not trigger a prompt
  } = props;
  const dispatch = useDispatch();

  const [prompt, setPrompt] = useState(null);
  const forceRedirect = useRef();

  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    window.onbeforeunload = (e) => {
      e.preventDefault();
      return e;
    };
    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  useEffect(() => {
    const unblock = history.block((newLocation) => {
      const isWhitelisted = locationsWhitelist.some((loc) => newLocation.pathname.includes(loc));
      const isSamePath = history.location.pathname === newLocation.pathname;
      if (!isWhitelisted && !isSamePath) {
        setPrompt({
          newLocation,
          unblock,
        });
        return !!forceRedirect.current;
      }
      return true;
    });
    return () => unblock();
  }, [history, locationsWhitelist]);

  return (
    <Modal open={Boolean(prompt)} onClose={() => setPrompt(null)}>
      <Modal.Header>{modalHeaderText}</Modal.Header>
      <Modal.Content>
        <p>{modalText}</p>
      </Modal.Content>
      <Modal.Actions>
        <div className={styles.modalButtonContainer}>
          <MainButton
            variant="text"
            color="secondary"
            onClick={() => {
              setPrompt(null);
              dispatch(setMustToLogOut(false));
              dispatch(setLeaveContractPage(false));
            }}
          >
            {t('leaveWarningModal.cancel')}
          </MainButton>
          <MainButton
            variant="contained"
            color="primary"
            onClick={() => {
              prompt.unblock(true);
              forceRedirect.current = true;
              dispatch(setLeaveContractPage(true));
              history.replace(prompt.newLocation.pathname);
            }}
          >
            {t('leaveWarningModal.confirm')}
          </MainButton>
        </div>
      </Modal.Actions>
    </Modal>
  );
};

LeaveWarningModal.propTypes = {
  modalHeaderText: PropTypes.string,
  modalText: PropTypes.string,
  locationsWhitelist: PropTypes.arrayOf(PropTypes.string),
};

LeaveWarningModal.defaultProps = {
  modalHeaderText: '',
  modalText: '',
  locationsWhitelist: [],
};

export default LeaveWarningModal;
